export const INPUT_COLOR:string='rgba(145, 158, 171, 0.08)';
export const PRIMARY_COLOR:string='#00AB55';
export const SECONDARY_COLOR:string='#11A2F1';
export const TEXT_TITLE_COLOR:string='#737373';
export const APP_BAR_COLOR:string='#F5FCFF';
export const SELECT_BACKGROUND_COLOR:string='#919EAB14';
export const TEXT_LIGHT_COLOR:string='#808080';
export const TEXT_HIGHLIGHT_COLOR:string='#11A2F1';
export const TABLE_HEADER_BACKGROUND_COLOR:string='#F4F6F8';